import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.set";
import _toConsumableArray from "D:/java/\u4E00\u7F51\u901A\u529E(\u529E\u4E8B\u5927\u53852.0)/\u4E00\u7F51\u901A\u529E\u524D\u7AEFPC/pc/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import treeMenu from "@/components/treeMenu/index.vue";
export default {
  components: {
    treeMenu: treeMenu
  },
  props: {
    dialogVisible: {
      type: Boolean,
      required: true,
      default: true
    }
  },
  data: function data() {
    return {
      arrIds: [],
      arrNames: []
    };
  },
  methods: {
    handleClose: function handleClose() {
      this.$emit("visibleClose");
    },
    getNodeId: function getNodeId() {},
    BoxClick: function BoxClick(val, data) {
      this.arrIds = _toConsumableArray(new Set(this.getChildIds(data)));
      this.arrNames = _toConsumableArray(new Set(this.getChildNames(data)));
    },
    getChildIds: function getChildIds(arr) {
      var _this = this;

      var ids = [];
      arr.forEach(function (i) {
        if (i.children.length == 0) {
          ids.push(i.id);
        } else {
          ids = ids.concat(_this.getChildIds(i.children));
        }
      });
      return ids;
    },
    getChildNames: function getChildNames(arr) {
      var _this2 = this;

      var names = [];
      arr.forEach(function (i) {
        if (i.children.length == 0) {
          names.push(i.name);
        } else {
          names = names.concat(_this2.getChildNames(i.children));
        }
      });
      return names;
    },
    submit: function submit() {
      this.$emit("submit", {
        names: this.arrNames,
        ids: this.arrIds
      });
    }
  }
};